import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../u1/Button";
import { CheckCircleIcon } from "../../../../assets/ui/icons";

/* Right-rail card 1 — the owner path.
 *
 * For someone who searched for their own business and did not find it. Copy
 * and the dark navy treatment come from the design export. */
const LINES = [
  "Free to list. Free to claim.",
  "Get found by the businesses looking for you.",
  "Build toward the Verified Member badge.",
];

/* The call to action's target is decided by the page, not here: it depends on whether there is a session, and this card stays free of store access like the... */
export const OwnerCard = ({
  ctaTo = "/sign-up",
  ctaState = { redirectToStep: 6 },
}) => (
  <section
    className="relative overflow-hidden rounded-[14px] p-6 text-white bg-[image:var(--owner-grad)]"
    aria-labelledby="u1-owner-heading"
  >
    <p className="text-[10.5px] font-bold tracking-[.1em] uppercase text-[var(--owner-eyebrow)] font-sans m-0 mb-2">
      For business owners
    </p>
    <h2 id="u1-owner-heading" className="text-[18px] font-bold leading-[1.3] font-sans m-0">
      Your business not here?
    </h2>
    <p className="text-[13px] leading-[1.55] text-[var(--owner-body)] font-sans mt-2 m-0">
      If your business is not showing, list it in about three minutes, whether it is in the UAE or
      trades with it. UAE businesses with an active trade licence are listed automatically, for
      free.
    </p>

    <ul className="mt-3 p-0 list-none grid gap-2">
      {LINES.map((line) => (
        <li
          key={line}
          className="flex gap-2.5 items-start text-[13px] leading-[1.45] text-[var(--owner-list)] font-sans"
        >
          <CheckCircleIcon />
          <span>{line}</span>
        </li>
      ))}
    </ul>

    <Link to={ctaTo} state={ctaState} className="block mt-4">
      <Button variant="primary" className="w-full whitespace-nowrap">
        List your business. It is free.
      </Button>
    </Link>
  </section>
);

export default OwnerCard;
